import { render, staticRenderFns } from "./VendorJobs.vue?vue&type=template&id=6059c988&"
import script from "./VendorJobs.vue?vue&type=script&lang=js&"
export * from "./VendorJobs.vue?vue&type=script&lang=js&"
import style0 from "./VendorJobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports